import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.loadingSubject.asObservable();

  show(): void {
    setTimeout(() => this.loadingSubject.next(true), 0);
  }

  hide(): void {
    setTimeout(() => this.loadingSubject.next(false), 0);
  }
}